export const adult = 'adult';
export const puppy = 'puppy';
